import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';

const INITIAL_COURSES = [
  { id: 1, title: 'HSE Basic Training', type: 'Mandatory', status: 'Active', enrolled: 45, color: 'bg-red-50 text-red-600' },
  { id: 2, title: 'Offshore Survival (BOSIET)', type: 'Specialized', status: 'Active', enrolled: 12, color: 'bg-blue-50 text-blue-600' },
  { id: 3, title: 'Leadership Fundamentals', type: 'Development', status: 'Scheduled', enrolled: 8, color: 'bg-purple-50 text-purple-600' },
];

const Training = () => {
  const [courses, setCourses] = useState(INITIAL_COURSES);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ title: '', type: 'Mandatory' });

  const handleAddCourse = (e) => {
    e.preventDefault();
    const newCourse = {
      id: Date.now(),
      title: formData.title,
      type: formData.type,
      status: 'Scheduled',
      enrolled: 0,
      color: formData.type === 'Mandatory' ? 'bg-red-50 text-red-600' : 'bg-blue-50 text-blue-600'
    };
    setCourses([...courses, newCourse]);
    setShowModal(false);
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Training & Development</h1>
          <p className="text-gray-500 text-sm">Manage L&D programs and mandatory certifications.</p>
        </div>
        <button 
          onClick={() => setShowModal(true)}
          className="bg-[#11469A] text-white px-4 py-2.5 rounded-lg font-bold text-sm shadow-sm hover:bg-[#0d3678] transition-all flex items-center gap-2"
        >
          <SafeIcon name="Plus" size={18} /> Add Course
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {courses.map((course, idx) => (
          <div key={idx} className="card p-6 border border-gray-100 shadow-sm relative overflow-hidden group">
            <div className="flex justify-between items-start mb-4">
              <span className={`px-2 py-1 rounded text-[10px] font-bold uppercase tracking-wider ${course.color}`}>{course.type}</span>
              <button className="text-gray-300 hover:text-[#11469A]"><SafeIcon name="MoreVertical" size={18} /></button>
            </div>
            <h3 className="text-lg font-bold text-gray-800 mb-2">{course.title}</h3>
            <div className="flex items-center gap-4 text-sm text-gray-500 mt-4">
              <span className="flex items-center gap-1.5"><SafeIcon name="Users" size={16} /> {course.enrolled} Enrolled</span>
              <span className="flex items-center gap-1.5"><SafeIcon name="Activity" size={16} /> {course.status}</span>
            </div>
          </div>
        ))}
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden animate-in slide-in-from-bottom-4 duration-200">
            <div className="p-5 border-b border-gray-100 flex justify-between items-center bg-[#f8f9fa]">
              <h3 className="font-bold text-[#11469A]">Add New Course</h3>
              <button onClick={() => setShowModal(false)} className="text-gray-400 hover:text-gray-600"><SafeIcon name="X" size={20} /></button>
            </div>
            <form onSubmit={handleAddCourse} className="p-6 space-y-4">
              <div>
                <label className="block text-[11px] font-bold text-gray-500 uppercase tracking-wider mb-1">Course Title</label>
                <input required type="text" className="w-full px-3 py-2 border border-gray-200 rounded text-sm focus:border-[#11469A] outline-none" value={formData.title} onChange={e => setFormData({...formData, title: e.target.value})} />
              </div>
              <div>
                <label className="block text-[11px] font-bold text-gray-500 uppercase tracking-wider mb-1">Category</label>
                <select className="w-full px-3 py-2 border border-gray-200 rounded text-sm focus:border-[#11469A] outline-none" value={formData.type} onChange={e => setFormData({...formData, type: e.target.value})}>
                  <option>Mandatory</option>
                  <option>Specialized</option>
                  <option>Development</option>
                </select>
              </div>
              <div className="pt-4 flex gap-3">
                <button type="button" onClick={() => setShowModal(false)} className="flex-1 py-2.5 border border-gray-200 text-gray-600 rounded font-bold text-sm hover:bg-gray-50">Cancel</button>
                <button type="submit" className="flex-1 py-2.5 bg-[#11469A] text-white rounded font-bold text-sm hover:bg-[#0d3678]">Save Course</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Training;